import React, { useRef } from 'react'
import './Searchbar.css'
import img_close from '../../../img_2/close.png';
import img_search from '../../../img/search_1.png'

export default function Searchbar({ searflag, setSearch }) {
  const searchRef = useRef();

  /* 回车 */
  const goSearch = (e) => {
    let keycode = e.keyCode
    if (keycode == "13" && searchRef.current.value != "") {
      window.location = "/page/search" + "?words=" + searchRef.current.value;
    }
  }
  /* 点击放大镜 */
  const gosearch = () => {
    if (searchRef.current.value != "") {
      window.location = "/page/search" + "?words=" + searchRef.current.value;
    }

  }
  

  const dis_none = () => {
    setSearch()
  }
  return (
    <div className={searflag ? "searchbar2 searchbar_dis" : "searchbar2"}>
      <img src="" alt="" />
      <div className="search_box">
        <input type="search" onKeyUp={goSearch} placeholder='search' ref={searchRef}/>
        <img src={img_search} alt="" onClick={gosearch} />
      </div>
      
      <img src={img_close} alt="" className='sear_c' onClick={dis_none} />
    </div>
  )
}
